import { motion } from "framer-motion";

export default function AppearOnScroll({ children }:{children:any}) {

    return (
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1.5 }}>
        {children}
      </motion.div>
    )
}